import { SupportSearchTypes } from '../actions/supportSearchAction';

const defaultState = {
  knowledgeBase: [],
  category: [],
  isLoading: false,
  listKBaseFilters: [],
  listCategoryFilters: [],
  dataFilters: [],
  totalItems: 0,
  isLoadingMore: false,
  isLoadingSearchAllKnowledge: true,
  kbListId: [],
};

const supportSearchReducer = (state = defaultState, action: any) => {
  const {
    kbAndCategoryFilter,
    knowledgeBase,
    category,
    knowledgeSearchResult,
    moreKnowledgeSearchResult,
    kbListId,
  } = action;

  const arraysEqual = (arr1: any[], arr2: any[]) => {
    return arr1?.every((item: any, index: number) => item?.id === arr2[index]?.id);
  };

  switch (action.type) {
    case SupportSearchTypes.SET_KNOWLEDGE_BASE:
      return {
        ...state,
        knowledgeBase,
      };
    case SupportSearchTypes.SET_CATEGORY:
      return {
        ...state,
        category,
      };
    case SupportSearchTypes.GET_KNOWLEDGE_BASE_AND_CATEGORY_FILTER:
      return {
        ...state,
        isLoading: true,
      };
    case SupportSearchTypes.GET_KNOWLEDGE_BASE_AND_CATEGORY_FILTER_SUCCESS:
      return {
        ...state,
        listKBaseFilters:
          !state.listKBaseFilters?.length ||
          !state.knowledgeBase?.length ||
          !state.knowledgeBase[0]
            ? kbAndCategoryFilter?.knowledge_base
            : state.listKBaseFilters,
        listCategoryFilters:
          !state.listCategoryFilters?.length ||
          !state.category?.length ||
          !state.category[0] ||
          !arraysEqual(state.listKBaseFilters, kbAndCategoryFilter?.knowledge_base)
            ? kbAndCategoryFilter?.category_tree
            : state.listCategoryFilters,
        isLoading: false,
      };
    case SupportSearchTypes.SEARCH_ALL_KNOWLEDGE_RESULT_SUCCESS:
      return {
        ...state,
        isLoadingSearchAllKnowledge: false,
        dataFilters: knowledgeSearchResult?.data,
        totalItems: knowledgeSearchResult?.totalCount,
      };
    case SupportSearchTypes.SEARCH_ALL_KNOWLEDGE_RESULT_FAIL:
      return {
        ...state,
        isLoadingSearchAllKnowledge: false,
      };
    case SupportSearchTypes.SEARCH_MORE_ALL_KNOWLEDGE_RESULT:
      return {
        ...state,
        isLoadingMore: true,
      };
    case SupportSearchTypes.SEARCH_MORE_ALL_KNOWLEDGE_RESULT_SUCCESS:
      return {
        ...state,
        isLoadingMore: false,
        dataFilters: [...state.dataFilters, ...moreKnowledgeSearchResult?.data],
      };
    case SupportSearchTypes.SEARCH_MORE_ALL_KNOWLEDGE_RESULT_FAIL:
      return {
        ...state,
        isLoadingMore: false,
      };
    case SupportSearchTypes.SET_KB_LIST_IDS:
      return {
        ...state,
        kbListId,
      };
  }

  return state;
};

export default supportSearchReducer;
